const styles = {
  root: {
    paddingBottom: 42,
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
};

export default styles;
